

import React from "react";
import "./ReusableModal.css";


const ReusableModal = ({
  show,
  onHide,
  title = "Notice",
  message,
  okText = "OK",
  cancelText,
  onOk,
  onCancel,
  backdrop = "static",
  variant = "default",
}) => {
  if (!show) return null;

  const handleOkClick = () => {
    if (onOk) onOk();
    else onHide();
  };

  const handleCancelClick = () => {
    if (onCancel) onCancel();
    else onHide();
  };

  const handleOverlayClick = (e) => {
    if (backdrop !== "static" && e.target === e.currentTarget) onHide();
  };

  return (
    <div className="rm-overlay" onClick={handleOverlayClick}>
      <div className="rm-box">

        {/* Header */}
        <div className={`rm-header rm-header--${variant}`}>
          <h5 className="rm-title">{title}</h5>
          <button className="rm-close" onClick={onHide}>×</button>
        </div>

        {/* Body */}
        <div className="rm-body">
          {typeof message === "string" ? (
            <p className="rm-message">{message}</p>
          ) : (
            message
          )}
        </div>

        {/* Footer */}
        <div className="rm-footer">
          {cancelText && (
            <button className="rm-btn rm-btn-cancel" onClick={handleCancelClick}>
              {cancelText}
            </button>
          )}
          <button className={`rm-btn rm-btn-ok rm-btn-ok--${variant}`} onClick={handleOkClick}>
            {okText}
          </button>
        </div>

      </div>
    </div>
  );
};

export default ReusableModal;